module.exports = __webpack_public_path__ + "res/ic_open_out.d0dab460e119fc07670efdc1baed8fb5.png";